import "core-js/modules/es6.number.constructor.js";
Number.prototype.getFormattedCurrency = function () {
  if (typeof this.valueOf() !== 'number') return this.valueOf();
  return this.toLocaleString('it-IT', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0
  });
};